import { BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { INDRAApiService } from './api.indra.service';
import { ModalService } from '@ibe/services/ui';
import { MOCK_STATUS, MOCK_URL_PAYMENT_METHOD, MOCK_URL_ENCRYPTED_AUTHORIZE, MOCK_URL_PAYMENT_TRANSACTION_STATUS, MOCK_URL_PAYMENT_ALIPAY, MOCK_URL_PAYMENT_PRP, MOCK_URL_PAYMENT_DELETE_SAVED_CARD, MOCK_URL_PAYMENT_CHECK_FOP, MOCK_URL_PAYMENT_MULTICAIXA, MOCK_URL_PAYMENT_BANKTRANSFER_PICKUP, MOCK_URL_PAYMENT_CC_FEE, MOCK_URL_PAYMENT_CC_FEE_ZERO, URL_PAYMENTHUB, URL_PAYMENT_IDENTIFYSHOPPER, URL_PAYMENT_CHALLANGESHOPPER, URL_GET_STATUS_TRANSACTION, URL_AUTHORISED, URL_PAYCARD_BOOKING, URL_PAYMENT_REDIRECT, URL_PAYMENT_PRP_CREATE_ORDER, URL_PAYMENT_REMOVE_SAVED_CARD, URL_PNR_EXTEND, URL_PAYMENT_DECLINED_VALIDATION, URL_PAYMENT_CHECK_FOP, URL_IP_ADDRESS_EXTERNAL_SERVICE, URL_PAYMENT_MULTICAIXA, URL_PAYMENT_WITHOUT_GATEWAY, URL_PAYMENT_APPLY_CC_FEE, MOCK_URL_REDEEM_VOUCHER, URL_REDEEM_VOUCHER, MOCK_PAYBYRD_CHECKOUT, URL_CHECKOUT_PAYBYRD, URL_PNR_REPORT_TO_KIBANA } from '@ibe.config';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../components/common/modal/modal.indra.service";
import * as i3 from "./api.indra.service";
var INDRAPaymentService = /** @class */ (function () {
    function INDRAPaymentService(http, modalService, api) {
        this.http = http;
        this.modalService = modalService;
        this.api = api;
        this._triggerHppRedFlag = new BehaviorSubject(false);
        this.triggerHppRedFlag$ = this._triggerHppRedFlag.asObservable();
    }
    INDRAPaymentService.prototype.INDRAGetPaymentMethods = function (market) {
        if (MOCK_STATUS.PAYMENT_METHOD) {
            return this.http.get(MOCK_URL_PAYMENT_METHOD);
        }
        else {
            return this.api.INDRA_post(URL_PAYMENTHUB, { market: market });
        }
    };
    INDRAPaymentService.prototype.INDRA_retrievePaymentMethods = function (market) {
        if (MOCK_STATUS.PAYMENT_METHOD) {
            return this.http.get(MOCK_URL_PAYMENT_METHOD);
        }
        else {
            return this.api.INDRA_get(URL_PAYMENTHUB + ("?market=" + market));
        }
    };
    INDRAPaymentService.prototype.INDRA_paymentCreditCard = function (pay) {
        if (MOCK_STATUS.ENCRYPTED) {
            return this.http.get(MOCK_URL_ENCRYPTED_AUTHORIZE); // uncomment if mock authorized issue ok
            // return this.http.get<INDRAPaymentCreditCard>(MOCK_URL_ENCRYPTED_AUTHORIZE_ISSUE_ERROR); // uncomment if mock authorized issue error
            // return this.http.get<INDRAPaymentCreditCard>(MOCK_URL_ENCRYPTED_AUTHORIZE_ISSUE_KO); // uncomment if mock authorized issue ko
            // return this.http.get<INDRAPaymentCreditCard>(MOCK_URL_ENCRYPTED_REDIRECTSHOPPER); // uncomment if mock redirectShopper
            // return this.http.get<INDRAPaymentCreditCard>(MOCK_URL_ENCRYPTED_IDENTIFYSHOPPER); // uncomment if mock identifyShopper
            // return this.http.get<INDRAPaymentCreditCard>(MOCK_URL_ENCRYPTED_REJECTED_CYBERSOURCE); // uncomment if mock rejected by cybersource
            // return this.http.get<INDRAPaymentCreditCard>(MOCK_URL_ENCRYPTED_REJECTED_FCE); // uncomment if mock rejected by fce
            // return this.http.get<INDRAPaymentCreditCard>(MOCK_URL_ENCRYPTED_REJECTED_FCE_A); // uncomment if mock rejected by fce (REJECT A)
            // return this.http.get<INDRAPaymentCreditCard>(MOCK_URL_ENCRYPTED_REVIEW); // uncomment if mock cybersource review
            // return this.http.get<INDRAPaymentCreditCard>(MOCK_URL_ENCRYPTED_REVIEW_FCE); // uncomment if mock fce review
            // return this.http.get<INDRAPaymentCreditCard>(MOCK_URL_ENCRYPTED_REFUSED); // uncomment if mock refused
            // return this.http.get<INDRAPaymentCreditCard>(MOCK_URL_ENCRYPTED_REDIRECTSHOPPER_OTHER_FOPS); // uncomment if mock redirect for other FOPs
        }
        else {
            return this.api.INDRA_post(URL_PAYCARD_BOOKING, pay);
        }
    };
    INDRAPaymentService.prototype.INDRA_paymentidentifyshopper = function (dataIdentifyShopper) {
        return this.api.INDRA_post(URL_PAYMENT_IDENTIFYSHOPPER, dataIdentifyShopper);
    };
    INDRAPaymentService.prototype.INDRA_challangeshopper = function (dataChallangeShopper) {
        return this.api.INDRA_post(URL_PAYMENT_CHALLANGESHOPPER, dataChallangeShopper);
    };
    INDRAPaymentService.prototype.INDRA_getStatusTransaction = function (dataIdOperation) {
        if (MOCK_STATUS.PAYMENT_TRANSACTION_STATUS) {
            return this.http.get(MOCK_URL_PAYMENT_TRANSACTION_STATUS);
        }
        else {
            return this.api.INDRA_post(URL_GET_STATUS_TRANSACTION, dataIdOperation);
        }
    };
    INDRAPaymentService.prototype.INDRA_authorised = function (dataAuthorised) {
        return this.api.INDRA_post(URL_AUTHORISED, dataAuthorised);
    };
    INDRAPaymentService.prototype.INDRA_paymentRedirectShopper = function (pay) {
        if (MOCK_STATUS.PAYMENT_REDIRECT) {
            return this.http.get(MOCK_URL_PAYMENT_ALIPAY);
            // return this.http.get<any>(MOCK_URL_ENCRYPTED_REDIRECTSHOPPER_OTHER_FOPS);
        }
        else {
            return this.api.INDRA_post(URL_PAYMENT_REDIRECT, pay);
        }
    };
    INDRAPaymentService.prototype.INDRA_paymentPRP = function (pay) {
        if (MOCK_STATUS.PAYMENT_PRP) {
            return this.http.get(MOCK_URL_PAYMENT_PRP);
        }
        else {
            return this.api.INDRA_post(URL_PAYMENT_PRP_CREATE_ORDER, pay);
        }
    };
    INDRAPaymentService.prototype.INDRA_removeSavedCard = function (req) {
        if (MOCK_STATUS.PAYMENT_REMOVE_SAVED_CARD) {
            return this.http.get(MOCK_URL_PAYMENT_DELETE_SAVED_CARD);
        }
        else {
            return this.api.INDRA_post(URL_PAYMENT_REMOVE_SAVED_CARD, req);
        }
    };
    INDRAPaymentService.prototype.INDRA_bookingPnrExtend = function () {
        return this.api.INDRA_post(URL_PNR_EXTEND, null);
    };
    INDRAPaymentService.prototype.INDRA_declinedValidation = function (request) {
        return this.api.INDRA_post(URL_PAYMENT_DECLINED_VALIDATION, request);
    };
    INDRAPaymentService.prototype.INDRA_bookingPnrReportToKibana = function (request) {
        return this.api.INDRA_post(URL_PNR_REPORT_TO_KIBANA, request);
    };
    INDRAPaymentService.prototype.INDRA_checkPaymentMethods = function () {
        if (MOCK_STATUS.PAYMENT_CHECK_FOP) {
            return this.http.get(MOCK_URL_PAYMENT_CHECK_FOP);
        }
        else {
            return this.api.INDRA_post(URL_PAYMENT_CHECK_FOP, null);
        }
    };
    INDRAPaymentService.prototype.INDRA_getIpAddress = function () {
        return this.http.get(URL_IP_ADDRESS_EXTERNAL_SERVICE);
    };
    INDRAPaymentService.prototype.INDRA_paymentMulticaixa = function (pay) {
        if (MOCK_STATUS.PAYMENT_MULTICAIXA) {
            return this.http.get(MOCK_URL_PAYMENT_MULTICAIXA);
        }
        else {
            return this.api.INDRA_post(URL_PAYMENT_MULTICAIXA, pay);
        }
    };
    INDRAPaymentService.prototype.INDRA_paymentWithoutGateway = function (pay) {
        if (MOCK_STATUS.PAYMENT_BANKTRANSFER_PICKUP) {
            return this.http.get(MOCK_URL_PAYMENT_BANKTRANSFER_PICKUP);
        }
        else {
            return this.api.INDRA_post(URL_PAYMENT_WITHOUT_GATEWAY, pay);
        }
    };
    INDRAPaymentService.prototype.INDRA_applyCCFee = function (surchargePercentage) {
        if (MOCK_STATUS.PAYMENT_CC_FEE) {
            var urlMock = surchargePercentage > 0 ? MOCK_URL_PAYMENT_CC_FEE : MOCK_URL_PAYMENT_CC_FEE_ZERO;
            return this.http.get(urlMock);
        }
        else {
            return this.api.INDRA_post("" + URL_PAYMENT_APPLY_CC_FEE + surchargePercentage, {});
        }
    };
    INDRAPaymentService.prototype.INDRA_redeemVoucher = function () {
        if (MOCK_STATUS.REDEEM_VOUCHER) {
            return this.http.get(MOCK_URL_REDEEM_VOUCHER);
        }
        else {
            return this.api.INDRA_post(URL_REDEEM_VOUCHER, {});
        }
    };
    INDRAPaymentService.prototype.INDRA_paybyrdCheckOut = function (dataPay) {
        if (MOCK_STATUS.PAYBYRD_CHECKOUT) {
            return this.http.get(MOCK_PAYBYRD_CHECKOUT);
        }
        else {
            return this.api.INDRA_post(URL_CHECKOUT_PAYBYRD, dataPay);
        }
    };
    INDRAPaymentService.prototype.INDRA_setTriggerHppRedFlag = function (value) {
        this._triggerHppRedFlag.next(value);
    };
    INDRAPaymentService.ngInjectableDef = i0.defineInjectable({ factory: function INDRAPaymentService_Factory() { return new INDRAPaymentService(i0.inject(i1.HttpClient), i0.inject(i2.ModalService), i0.inject(i3.INDRAApiService)); }, token: INDRAPaymentService, providedIn: "root" });
    return INDRAPaymentService;
}());
export { INDRAPaymentService };
